import { render, staticRenderFns } from "./Tethered.vue?vue&type=template&id=6031e1e4&scoped=true&"
import script from "./Tethered.vue?vue&type=script&lang=ts&"
export * from "./Tethered.vue?vue&type=script&lang=ts&"
import style0 from "./Tethered.vue?vue&type=style&index=0&id=6031e1e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6031e1e4",
  null
  
)

export default component.exports